export default function() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  return typeof window?.TelegramWebview !== 'undefined'
}
